export default __webpack_public_path__ + "static/media/more.1c30f31e.svg";